export const CONTRACT_TYPE_OPTIONS = ['FTE', 'C2H', 'FTE/C2H'];

export function isValidContractType(value) {
  return CONTRACT_TYPE_OPTIONS.includes(String(value || '').trim());
}
